var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:['el-span', _vm.type],on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }